import type { CounterData } from "../../../../../../DataSheet/DataSheet";

/**
 * Removes the meter identifier prefix from label values like
 * `MeteringOrMarketLocation.123 - Verbrauch / Entnahme` to `Verbrauch / Entnahme`
 */
export function cleanMeterLabels(data: CounterData | undefined) {
  if (!data?.labels) return data;

  return {
    ...data,
    labels: Object.entries(data.labels).reduce(
      (acc, [key, label]) => ({
        ...acc,
        [key]: label.includes(" - ") ? label.split(" - ")[1] : label
      }),
      {}
    )
  };
}
